module.exports = __webpack_public_path__ + "static/img/phone-BR.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-BR.png
// module id = ea/T
// module chunks = 1